// Export the Component Definition for use in Contentful Studio
export {BadgeContentfulComponentDefinition} from './BadgeContentfulDefinition';
export {default} from './Badge';
